/* global $, dataLayer */

import { Controller } from 'stimulus';
import hasHistorySupport from '../helpers/hasHistorySupport';

function updateUrl(url) {
  if (hasHistorySupport()) {
    window.history.replaceState(null, null, url);
  }
}

function getProductVariantHtml(url) {
  return $.ajax({
    url,
  });
}

function outputProductVariant(html) {
  const $blocksToReplace = $(html).filter('.js-ajax-replace');

  if ($blocksToReplace.length) {
    $blocksToReplace.toArray().forEach((block) => {
      const replaceId = block.getAttribute('data-replace-id');
      const replaceElement = document.querySelector(`[data-replace-id="${replaceId}"]`);

      if (replaceElement) {
        replaceElement.innerHTML = block.innerHTML;
      }
    });
  }
}

class OrderForm extends Controller {
  onVariantSelect(e) { // eslint-disable-line class-methods-use-this
    const productUrl = e.target.getAttribute('data-product-url');

    updateUrl(productUrl);

    getProductVariantHtml(productUrl)
      .then(outputProductVariant);
  }

  onSubmit(event) {
    const id = event.currentTarget.getAttribute('data-variant-id');
    const price = event.currentTarget.getAttribute('data-price');

    this.sendToGTM(id, price);
  }

  // eslint-disable-next-line
  sendToGTM(id, price) {
    dataLayer.push({
      event: 'add_to_cart',
      conversion_value: price || 0,
      product_id: id,
    });
  }
}

OrderForm.targets = [
  //
];

export default OrderForm;
